class YoutubeEmbed {
  constructor(el) {
    this.el = el;
    this.isPlaying = false;
    this.trigger = this.el.querySelector('.a-youtubeEmbed__trigger');
    this.trigger.addEventListener("click", this.play.bind(this));
    this.youtubeID = this.el.dataset.youtubeid;

    this.youtubeReadyListener();
  }

  youtubeReadyListener() {
    var youtubeReady = new Event('youtubeReady');

    if (!window.otoYoutubeReady) {
      window.otoYoutubeReady = true;
      var tag = document.createElement('script');
      tag.src = "https://www.youtube.com/iframe_api";
      var firstScriptTag = document.head.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

      window.onYouTubeIframeAPIReady = function() {
        window.dispatchEvent(youtubeReady);
      }
    } else {
      window.dispatchEvent(youtubeReady);
    }
  }

  play() {
    var $this = this;
    $this.isPlaying = true;
    $this.el.classList.add("is-playing");

    var player;
    if (window.otoYoutubeReady) {
      renderVideo();
    } else {
      window.addEventListener('youtubeReady', function() {
        renderVideo();
      });
    }

    function renderVideo() {
      player = new YT.Player('yt-' + $this.youtubeID, {
        height: '315',
        width: '560',
        videoId: $this.youtubeID,
        frameborder: 0,
        playerVars: {
          'playsinline': 1,
          'modestbranding': 1,
          'rel': 0,
          'cc_load_policy': 1,
          'allowfullscreen': 1
        },
        events: {
          'onReady': onPlayerReady,
          'onStateChange': onPlayerStateChange
        }
      })
    }

    function onPlayerReady(event) {
      event.target.playVideo();
    }

    var done = false;
    function onPlayerStateChange(event) {
      if (event.data == YT.PlayerState.PLAYING && !done) {
        done = true;
      }
    }

  }

}

function findYoutubeEmbeds() {
  Array.from(document.querySelectorAll(".a-youtubeEmbed")).forEach(
    (item) => initYoutubeEmbed(item)
  );
}

function initYoutubeEmbed(item) {
  new YoutubeEmbed(item);
}

window.addEventListener("DOMContentLoaded", function () {
  findYoutubeEmbeds();

  window.Livewire.hook('message.processed', function() {
    findYoutubeEmbeds();
  });
});
